import EmblaCarousel from "embla-carousel";
import { setupSliderDots } from "./slider-dots.js";

const getSlidesPerStep = (slider) => {
  const raw = getComputedStyle(slider)
    .getPropertyValue("--card-slider-per-view")
    .trim();
  const parsed = Number.parseInt(raw, 10);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : 3;
};

const positionArrows = (slider, embla) => {
  if (!window.matchMedia("(max-width: 1200px)").matches) {
    slider
      .querySelectorAll("[data-card-slider-prev], [data-card-slider-next]")
      .forEach((arrow) => {
        arrow.style.removeProperty("top");
      });
    return;
  }

  const stage = slider.querySelector(".card-slider__stage");
  const prev = slider.querySelector("[data-card-slider-prev]");
  const next = slider.querySelector("[data-card-slider-next]");
  const selectedSlide = embla.slideNodes()[embla.selectedScrollSnap()];
  const image = selectedSlide?.querySelector(".card__image-wrapper");

  if (!stage || !prev || !next || !image) {
    return;
  }

  const stageTop = stage.getBoundingClientRect().top;
  const imageRect = image.getBoundingClientRect();
  const top = `${
    imageRect.top + imageRect.height / 2 - stageTop - prev.offsetHeight / 2
  }px`;

  prev.style.top = top;
  next.style.top = top;
};

const initCardSlider = (slider) => {
  const viewport = slider.querySelector(".card-slider__viewport");

  if (!viewport) {
    return;
  }

  let slidesPerStep = getSlidesPerStep(slider);

  const embla = EmblaCarousel(viewport, {
    align: "start",
    loop: true,
    duration: 35,
    slidesToScroll: slidesPerStep,
  });

  const setSlideVisibility = () => {
    const slidesInView = embla.slidesInView();

    embla.slideNodes().forEach((slide, index) => {
      slide.classList.toggle("is-in-view", slidesInView.includes(index));
    });

    slider.classList.add("is-ready");
    positionArrows(slider, embla);
  };

  const syncSlidesPerStep = () => {
    const nextSlidesPerStep = getSlidesPerStep(slider);

    if (nextSlidesPerStep === slidesPerStep) {
      return;
    }

    slidesPerStep = nextSlidesPerStep;
    embla.reInit({ slidesToScroll: slidesPerStep });
  };

  slider
    .querySelector("[data-card-slider-prev]")
    ?.addEventListener("click", () => {
      embla.scrollPrev();
    });

  slider
    .querySelector("[data-card-slider-next]")
    ?.addEventListener("click", () => {
      embla.scrollNext();
    });

  setupSliderDots(slider.querySelector("[data-slider-dots]"), embla, "page");

  [
    window.matchMedia("(max-width: 768px)"),
    window.matchMedia("(max-width: 980px)"),
  ].forEach((mediaQuery) => {
    mediaQuery.addEventListener("change", syncSlidesPerStep);
  });

  const resizeObserver = new ResizeObserver(() => {
    positionArrows(slider, embla);
  });
  resizeObserver.observe(viewport);

  embla.on("select", setSlideVisibility);
  embla.on("slidesInView", setSlideVisibility);
  embla.on("reInit", setSlideVisibility);

  setSlideVisibility();
};

document.querySelectorAll("[data-card-slider]").forEach(initCardSlider);
